<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<form [formGroup]="editForm" [windeDisableFormControls]="viewInReadOnly ? editForm : null" class="clr" name="editForm">
    <h5 class="mb-3">Select Products</h5>
    <div class="grid" formArrayName="productsToUse">
        <!-- BODY -->
        @for (product of products.controls; track prodIndex; let prodIndex = $index) {
            <div [formGroupName]="'' + prodIndex" class="grid-row">
                <div class="grid-row__cell link">
                    <span>Link short name</span>
                </div>
                <div class="grid-row__cell link-name">
                    <input
                            (change)="checkLinkNameValidity()"
                            class="form-control form-control-sm"
                            formControlName="bomLinkName"
                            id="bomLinkName_{{ prodIndex }}"
                    />
                </div>
                <div class="grid-row__cell use">
                    <span>use</span>
                </div>
                <div class="grid-row__cell product">
                    <select
                            (change)="checkSelectedProduct(product)"
                            class="form-control form-control-sm"
                            formControlName="usedProd"
                            id="device_{{ prodIndex }}"
                    >
                        <option [ngValue]="null">none</option>
                        @for (productItem of firstProductOfLinkList; track productItem) {
                            <option [ngValue]="productItem.id">
                                {{ productItem.name === 'MultiHaul' ? 'MH-BU' : productItem.name }}
                            </option>
                        }
                    </select>
                </div>
                <div class="grid-row__cell antenna">
                    @if (product.get('usedProd').value !== null) {
                        <select class="form-control form-control-sm" formControlName="usedAnt0" id="type_{{ prodIndex }}">
                            @for (antennaItem of availableAntennas[product.get('usedProd').value]; track antennaItem) {
                                <option [ngValue]="antennaItem.id">
                                    {{ antennaItem.name }}
                                </option>
                            }
                        </select>
                    }
                </div>
                <div class="grid-row__cell product">
                    @if (hasToShowTUProduct(product.get('usedProd').value)) {
                        <select class="form-control form-control-sm" formControlName="usedProdTU" id="second_device_{{ prodIndex }}">
                            @for (productItem of secondLinkProductsList[product.get('usedProd').value]; track productItem) {
                                <option [ngValue]="productItem.id">
                                    {{ productItem.name === 'MultiHaul' ? 'MH-BU' : productItem.name }}
                                </option>
                            }
                        </select>
                    }
                </div>
                <div class="grid-row__cell antenna">
                    @if (hasToShowTUProduct(product.get('usedProd').value)) {
                        <select class="form-control form-control-sm" formControlName="usedAnt1">
                            @for (antennaItem of availableAntennas[product.get('usedProdTU').value]; track antennaItem) {
                                <option [ngValue]="antennaItem.id">
                                    {{ antennaItem.name }}
                                </option>
                            }
                        </select>
                    }
                </div>
            </div>
        }
    </div>

    @if (hasMhProduct) {
        <div class="row" formGroupName="defaultMHProducts">
            <div class="form-group col-6">
                <span class="form-label" for="defaultBu">{{ 'project.defaultBuRadio' | translate }}</span>
                <div class="d-flex align-items-center">
                    <select class="form-control form-control-sm" formControlName="defaultBuProductPerLayer" id="defaultBu">
                        @for (buRadio of availableBu; track buRadio) {
                            <option [ngValue]="buRadio.key">{{ buRadio.value }}</option>
                        }
                    </select>
                    <winde-ctx-sensitive-help placement="bottom" tooltipTextPath="productRadioName.btn.openProductPage">
                        <div [isUseInfoButton]="true" [outerLink]="getLink(defaultBUName)" class="ml-2 my-auto" windeProductNameLink></div>
                    </winde-ctx-sensitive-help>
                </div>
            </div>
            <div class="form-group col-6">
                <span class="form-label" for="defaultTu">{{ 'project.defaultTuRadio' | translate }}</span>
                <div class="d-flex align-items-center">
                    <select
                            (change)="updateDefaultProductsPerLayer()"
                            class="form-control form-control-sm"
                            formControlName="defaultTuProductPerLayer"
                            id="defaultTu"
                    >
                        @for (tuRadio of availableTu; track tuRadio) {
                            <option [ngValue]="tuRadio.key">{{ tuRadio.value }}</option>
                        }
                    </select>
                    <winde-ctx-sensitive-help placement="bottom" tooltipTextPath="productRadioName.btn.openProductPage">
                        <div [isUseInfoButton]="true" [outerLink]="getLink(defaultTUName)" class="ml-2 my-auto" windeProductNameLink></div>
                    </winde-ctx-sensitive-help>
                </div>
            </div>
        </div>
    }
</form>
